/** Oct-2026 (founder) — tarjetas de regalo · pedir reseña · campañas de barbería · avisos masivos · solicitudes de torneo. */
import { api } from '@/lib/api';
import { fmtMoney } from '@/utils/money';

export const giftCardsApi = {
  availability() { return api.get('/gift-cards/availability'); },
  checkout(body) { return api.post('/gift-cards/checkout', body); },
  mine() { return api.get('/gift-cards/mine'); },
  check(code) { return api.get(`/gift-cards/check/${encodeURIComponent(code)}`); },
};

export const reviewLinksApi = {
  mine() { return api.post('/reviews/request-link'); },
  rotate() { return api.post('/reviews/request-link/rotate'); },
  info(token) { return api.get(`/reviews/link/${encodeURIComponent(token)}`); },
  create(token, body) { return api.post(`/reviews/link/${encodeURIComponent(token)}`, body); },
};

export const shopCampaignsApi = {
  recipients() { return api.get('/shop/campaigns/recipients'); },
  list() { return api.get('/shop/campaigns'); },
  send(body) { return api.post('/shop/campaigns', body); },
};

export const broadcastsApi = {
  preview(body) { return api.post('/admin/broadcasts/preview', body); },
  send(body) { return api.post('/admin/broadcasts', body); },
  history() { return api.get('/admin/broadcasts'); },
};

export const tournamentRequestsApi = {
  create(body) { return api.post('/tournament-requests', body); },
  mine() { return api.get('/tournament-requests/mine'); },
  adminList(status) { return api.get(`/admin/tournament-requests${status ? `?status=${status}` : ''}`); },
  decide(id, body) { return api.post(`/admin/tournament-requests/${id}/decision`, body); },
};

const DEVICE_KEY = 'lineage_device_id';
export const deviceId = () => {
  try {
    let v = localStorage.getItem(DEVICE_KEY);
    if (!v) {
      v = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`).replace(/-/g, '').slice(0, 32);
      localStorage.setItem(DEVICE_KEY, v);
    }
    return v;
  } catch { return `mem-${Date.now()}`; }
};

export const money = (cents) => fmtMoney(Number(cents || 0) / 100);
